module.exports = __webpack_public_path__ + "../static/img/databanks-icon.06f55e4d.png";